/**
 * TypeScript types for Facility Management
 */

export enum CareType {
  SNF = 'SNF',
  HOSPICE = 'HOSPICE',
  ALF = 'ALF',
  BOTH = 'BOTH',
}

export interface FacilityDTO {
  id?: string;
  name: string;
  code: string;
  clientId: string;
  admissionType: CareType;
  email?: string;
  phone: string;
  fax?: string;
  address: string;
  city: string;
  state: string;
  country: string;
  postalCode: string;
  subdomain?: string;
  licenseNumber?: string;
  npiNumber?: string;
  medicareProviderNumber?: string;
  medicaidProviderNumber?: string;
  capacity?: number;
  isActive?: boolean;
  timezone?: string;
  logoUrl?: string;
  website?: string;
  notes?: string;
  createdAt?: string;
  updatedAt?: string;
  clientName?: string;
  activeResidentsCount?: number;
  isPrimary?: boolean;
}

export interface CreateFacilityRequest {
  name: string;
  code: string;
  clientId: string;
  admissionType: CareType;
  email?: string;
  phone: string;
  fax?: string;
  address: string;
  city: string;
  state: string;
  country: string;
  postalCode: string;
  subdomain?: string;
  licenseNumber?: string;
  npiNumber?: string;
  medicareProviderNumber?: string;
  medicaidProviderNumber?: string;
  capacity?: number;
  timezone?: string;
  logoUrl?: string;
  website?: string;
  notes?: string;
}

export interface PageResponse<T> {
  content: T[];
  totalElements: number;
  totalPages: number;
  size: number;
  number: number;
  first: boolean;
  last: boolean;
  empty: boolean;
}
